export enum ButtonType {
  Fill = 'fill',
  Outline = 'outline',
}
